module.exports = __webpack_public_path__ + "img/애고미_이모티콘-06.7a7fc28.png";